// Row.jsx
export const Row = ({ label, hint, children }) => (
  <div className="set-row">
    <label className="set-label">{label}</label>
    <div className="set-field">
      {children}
      {hint && <p className="set-hint">{hint}</p>}
    </div>
  </div>
);
